type LocalStorageKey = `box${string}`;
export const LOCAL_STORAGE_KEYS = {
  USER_TEST_GROUP: {
    legacyKey: 'USER_TEST_GROUP',
    key: 'boxUserTestGroup',
  },
  LOGIN_INFO: {
    legacyKey: 'LOGIN_INFO',
    key: 'boxLoginInfo',
  },
  TOGHOL_BACKEND: {
    legacyKey: 'TOGHOL_BACKEND',
    key: 'boxTogholBackend',
  },
  POST_LOGIN_REDIRECTION: {
    legacyKey: 'POST_LOGIN_REDIRECTION',
    key: 'boxPostLoginRedirection',
  },
  BOX_COURIER_HEARING_IMPAIRED: {
    legacyKey: 'BOX_COURIER_HEARING_IMPAIRED',
    key: 'boxCourierHearingImpaired',
  },
  HAS_SEEN_PARALLEL_REQUEST_ON_BOARDING: {
    legacyKey: 'BOX_HAS_SEEN_PARALLEL_REQUEST_ON_BOARDING',
    key: 'boxHasSeenParallelRequestOnBoarding',
  },
  HAS_SEEN_FILL_RENDEZVOUS_ON_BOARDING: {
    key: 'boxHasSeenFillRendezvousOnBoardingV2',
  },
  FILL_RENDEZVOUS_TOOLTIP_VIEW_COUNT: {
    key: 'boxFillRendezvousTooltipViewCount',
  },
  USER_ID: {
    legacyKey: 'box_userId',
    key: 'boxUserId',
  },
  BOX_LATEST_URL: {
    legacyKey: 'BOX_LATEST_URL',
    key: 'boxLatestUrl',
  },
  BOX_HOME_FILTER_BADGE_SEEN: {
    legacyKey: 'BOX_HOME_FILTER_BADGE_SEEN',
    key: 'boxHomeFilterBadgeSeen',
  },
  BOX_SEEN_AUTO_RETRY_TOAST: {
    legacyKey: 'BOX_SEEN_AUTO_RETRY_TOAST',
    key: 'boxSeenAutoRetryToast',
  },
  PARTY_SUGGESTION_SHIMMER_SEEN: {
    legacyKey: 'BOX_PARTY_SUGGESTION_SHIMMER_SEEN',
    key: 'boxPartySuggestionShimmerSeen',
  },
  LATEST_SENDER_LOCATION: {
    legacyKey: 'BOX_LATEST_SENDER_LOCATION',
    key: 'boxLatestSenderLocation',
  },
  LOCAL_STORAGE_MIGRATION_VERSION: {
    key: 'boxLocalStorageMigrationVersion',
  },
} as const satisfies Record<string, { legacyKey?: string; key: LocalStorageKey }>;
